
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Gallery</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Gallery</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
          <!-- Small boxes (Stat box) -->
         
        <div class="row">
          <div class="col-12">
            <div class="card card-danger card-outline">
                <div class="card-header">
                  <h4 class="card-title">Albums</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-2 col-4" *ngFor="let glname of galfolder"  >
                     
                        <img src="assets/dist/img/fold2.png" class="img-fluid mb-2" alt="white sample" (click)="galimges()" >
                    
                      <p class=" text-justify">{{glname.foldername}}</p>
                    </div>
                  
                  </div>
                </div>
              </div>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->